import _ from "lodash";
import Helper from "helper";

const USUnitNameList = [
  "px", // none
  "percent",
  "dB",
  "mm", //"cm",
  "seconds",
  "hertz",
  "dB/seconds",
  "cm/sec",
  "cm2",
  "cm2/sec",
  "cm3",
  "cm3/sec",
  "degrees",
  "(null)",
];

function getUnitInUS(physicalUnitNumber) {
  let unit = 0;
  if (physicalUnitNumber < 0 || physicalUnitNumber > USUnitNameList.length) {
    return "";
  }
  return USUnitNameList[physicalUnitNumber];
}

function getPhysicalDirectionUnit(dcmImage) {
  const modality = dcmImage.modality;
  if (modality.toLowerCase() !== "us") {
    return { unitX: -1, unitY: -1 };
  }
  const ultrasoundRegions = dcmImage.ultrasoundRegions;
  if (Helper.Validator.isDefined(ultrasoundRegions) === false) {
    return { unitX: -1, unitY: -1 };
  }
  if (ultrasoundRegions.length < 1) {
    return { unitX: -1, unitY: -1 };
  }
  const unitsX = ultrasoundRegions[0].unitsX;
  const unitsY = ultrasoundRegions[0].unitsY;

  return { x: unitsX, y: unitsX };
}

/**
 * 입력 모달리티에서 사용하는 PixelSpacing 값을 DICOM 태그에서 반환
 * @param {String} modality DICOM modality string e.g, CT, MR, US etc...
 * @returns {number, number}  {pixelSpacingX, pixelSpacingY}
 *                            반환할 pixelSpacing이 없다면, {0, 0}
 */
function getPixelSpacingByModality(modality, dcmImage) {
  let pixelSpacingX = 0;
  let pixelSpacingY = 0;
  if (
    !Helper.Validator.isDefined(modality) &&
    !Helper.Validator.isDefined(modality)
  ) {
    return { x: pixelSpacingX, y: pixelSpacingY };
  }



  /**
   * DICOM 영상의 모달리티에 따른 Pixel Spacing 값을 획득
   * US(Ultrasound) 영상일 경우, Physical Direction Unit X/Y 태그를 사용
   * 이외에 PixelSpacing 태그가 없는 경우 0을 반환
   */
  if (modality.toLowerCase() === "us") {
    const ultrasoundRegions = dcmImage.ultrasoundRegions;
    if (Helper.Validator.isDefined(ultrasoundRegions) === false) {
      const pixelSpacing = dcmImage.pixelSpacing;
      if (Helper.Validator.isDefined(pixelSpacing) === false) {
        return { x: 0, y: 0 };
      }
      pixelSpacingX = pixelSpacing[0];
      pixelSpacingY = pixelSpacing[1];
      return { x: pixelSpacingX, y: pixelSpacingY };
    }
    if (ultrasoundRegions.length < 1) {
      const pixelSpacing = dcmImage.pixelSpacing;
      if (Helper.Validator.isDefined(pixelSpacing) === false) {
        return { x: 0, y: 0 };
      }
      pixelSpacingX = pixelSpacing[0];
      pixelSpacingY = pixelSpacing[1];
      return { x: pixelSpacingX, y: pixelSpacingY };
    }
    pixelSpacingX = ultrasoundRegions[0]["deltaX"];
    pixelSpacingY = ultrasoundRegions[0]["deltaY"];
  } else {
    const pixelSpacing = dcmImage.pixelSpacing || 1;
    if (Helper.Validator.isDefined(pixelSpacing) === false) {
      return { x: 0, y: 0 };
    }
    pixelSpacingX = pixelSpacing[0];
    pixelSpacingY = pixelSpacing[1];
  }

  return { x: pixelSpacingX, y: pixelSpacingY };
}

function getPhysicsAlphaByUnit(dcmImage) {
  const modality = dcmImage.modality;
  if (modality.toLowerCase() !== "us") {
    return 0;
  }
  const ultrasoundRegions = dcmImage.ultrasoundRegions;
  if (Helper.Validator.isDefined(ultrasoundRegions) === false) {
    return 0;
  }
  if (ultrasoundRegions.length < 1) {
    return 0;
  }
  const unitsX = ultrasoundRegions[0].unitsX;

  return { x: unitsX, y: unitsX };
}

const DICOM = {
  getPixelSpacingByModality,
  getPhysicalDirectionUnit,
  getUnitInUS,
};

export default DICOM;
